import { isNativeIOS } from './platform';

export type AppleSignInResult = {
  identityToken: string;
  givenName?: string;
  familyName?: string;
};

export async function signInWithAppleNative(): Promise<AppleSignInResult> {
  if (!isNativeIOS()) {
    throw new Error('Sign in with Apple is only available on the iOS app.');
  }
  const { SignInWithApple } = await import('@capacitor-community/apple-sign-in');
  const res = await SignInWithApple.authorize({
    clientId: 'com.peakperformanceiq.app',
    redirectURI: 'https://peakperformanceiq.com/auth/apple/callback',
    scopes: 'email name',
  });
  const token = res.response.identityToken;
  if (!token) throw new Error('Apple did not return an identity token.');
  return {
    identityToken: token,
    givenName: res.response.givenName ?? undefined,
    familyName: res.response.familyName ?? undefined,
  };
}
